/**
 * @generated SignedSource<<c08d9dcda3dd64bbf367388bf948be9a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type progressSummary_issueViewChildIssuesPanel$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly statusField: {
        readonly status: {
          readonly statusCategory: {
            readonly statusCategoryId: string;
          };
        } | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "progressSummary_issueViewChildIssuesPanel";
};
export type progressSummary_issueViewChildIssuesPanel$key = {
  readonly " $data"?: progressSummary_issueViewChildIssuesPanel$data;
  readonly " $fragmentSpreads": FragmentRefs<"progressSummary_issueViewChildIssuesPanel">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "progressSummary_issueViewChildIssuesPanel",
  "selections": [
    {
      "concreteType": "JiraIssueEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "JiraIssue",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraStatusField",
              "kind": "LinkedField",
              "name": "statusField",
              "plural": false,
              "selections": [
                {
                  "concreteType": "JiraStatus",
                  "kind": "LinkedField",
                  "name": "status",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "RequiredField",
                      "field": {
                        "concreteType": "JiraStatusCategory",
                        "kind": "LinkedField",
                        "name": "statusCategory",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "statusCategoryId"
                          }
                        ]
                      },
                      "action": "LOG",
                      "path": "edges.node.statusField.status.statusCategory"
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraIssueConnection"
};

(node as any).hash = "6031fdf648d4e180026ffea9139024f1";

export default node;
